import React from "react";
import "./VirasatInputComponents.scss"
import PhoneInput from 'react-phone-number-input'

const PhoneInputComponent = ({ label, value, onChange, placeholder, required, error, errorText, disable }) => {
    return (
        <div className="VirasatInputComponents-VirasatDefault">
            <div className="input-label">
                {label}
                {required && <span className="input-req">* </span>}
            </div>
            <div className={`VirasatInputComponents-VirasatDefault-container ${error ? "error" : disable ? "disable" : ""}`}>
                <PhoneInput
                    defaultCountry="GB"
                    placeholder={placeholder}
                    value={value}
                    onChange={onChange}
                    className="VirasatInputComponents-VirasatDefault-container-input"
                    disabled={disable ?? false}

                />
            </div>
            {errorText !== "" && < div className="input-error-text">
                {errorText}
            </div>}
        </div>
    )
}
export default PhoneInputComponent